// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"cc1e814f","522":"33739d5b","548":"1a3f48ae","563":"15c488de","756":"3b7e5985","768":"ba168da3","791":"9f7c09bb","825":"0a145adf","914":"6e280e14","979":"c96f4fa6"}[chunkId] + ".chunk.js";
};